import React from 'react';

import * as styles from './index.module.styl';

import Rebrand from '../variants/rebrand';
import Form404 from './form-404';
//import PupperformHomePage from '../variants/pupperform';

class IndexPage extends React.Component {
  render() {
    return (
      <Form404 {...this.props}>
        <Rebrand {...this.props} variant={true} />
      </Form404>
    );
  }
}

export default IndexPage;
